import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { PreviewCompanyDocumentModalComponent } from 'src/app/pages/dashboards/files-clients/modals/preview-company-document-modal/preview-company-document-modal.component';
import { DocumentTemplateApiCallerService, UsedTemplate, UsedTemplateDocuments } from 'src/app/pages/document-templates/services/document-template-api-caller.service';
import { SigningTypeViewModel, SigningTypes, SigningTypeEnum } from 'src/app/features/signing/models/signing.model';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-new-document-client',
  templateUrl: './new-document-client.component.html',
  styleUrl: './new-document-client.component.scss'
})
export class NewDocumentClientComponent {

  public signingTypes: SigningTypeViewModel[] = SigningTypes;

  public form: FormGroup;
  public documentUses: UsedTemplateDocuments[];
  used = Object.entries(UsedTemplate)
  .filter(([key, value]) => !isNaN(Number(value))) 
  .filter(([key, value]) => [1,2,3,7,8].includes(Number(value)))
  //.filter(([key, value]) => [1, 2, 3, 8].includes(Number(value)))
  .map(([key, value]) => ({ key, value }));

  constructor(private serviceDocument: DocumentTemplateApiCallerService, public dialog: MatDialog, private fb: FormBuilder, @Inject(MAT_DIALOG_DATA)public companyId: number, private dialogRef: MatDialogRef<NewDocumentClientComponent>) {

  }

  ngOnInit(): void {
    this.getUsedDocuemntTemplate();
    this.form = this.fb.group({
      signingType: [ SigningTypeEnum.SES, [Validators.required]],
      documentType: [undefined, [Validators.required]],
    });
  }

  public getUsedDocuemntTemplate() {
    this.serviceDocument.getUsesDocumenTemplates().subscribe({
      next:(res) => {
        this.documentUses = res.filter((use: UsedTemplateDocuments) => use.typeName.toUpperCase() === "CONTRATO");
      }, 
      error: (err) => {
        console.log(err);
      }
    });
  }

  public generarDocumento() {
    Swal.fire({
      title: 'Generando documento...',
      text: 'Se guardara en los documentos del cliente',
      didOpen: () => {
        Swal.showLoading();
      }
    });
    const signatureType = this.form.get('signingType')?.value;
    const selectedValue = this.form.get('documentType')?.value;
    const observer = {
      next: (data: any) => {
        Swal.fire({
          title: 'Documento Creado',
          text: 'Se guardó en documentos del cliente',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        }).then((result) => {
          if (result.isConfirmed) {
            this.dialogRef.close(true);
          }
        });
        
      },
      error: (error: any) => {
        console.error('Error fetching document template', error);
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al generar el documento',
          icon: 'error'
        });
      },
      complete: () => {
        console.log('Document template loaded successfully');
      }
    };
    this.serviceDocument.generateDocumentClient(selectedValue, this.companyId, signatureType)
    .subscribe(observer);
  }

  public generarBorrador() {
    Swal.fire({
      title: 'Generando borrador...',
      text: 'No se guardara en los documentos del cliente',
      didOpen: () => {
        Swal.showLoading();
      }
    });
    const selectedValue = this.form.get('documentType')?.value;
    const observer = {
      next: (data: any) => {
        console.log("Listo");
        this.viewDraftDocument(data.value);
      },
      error: (error: any) => {
        console.error('Error fetching document template', error);
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al generar el borrador',
          icon: 'error'
        });
      },
      complete: () => {
        console.log('Document template loaded successfully');
        Swal.close();
      }
    };
    this.serviceDocument.downloadDocumentDraft(selectedValue, this.companyId).subscribe(observer);
  }

  public viewDraftDocument(base64: string) {
    const selectedValue = this.form.get('documentType')?.value;
    const data = {
      viewOnly: true,
      base64: base64,
      draft: true,
      name: UsedTemplate[selectedValue] + " - Documento Borrador"
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '80vw';
    dialogConfig.height = '95vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '95vh';
    dialogConfig.data = data;
    this.dialog.open(PreviewCompanyDocumentModalComponent, dialogConfig);
  }
  
}